import { useQuery } from '@apollo/client';
import { GET_USER_ADDRESSES } from '../services';
// TODO consider moving this to a separate package
const useGetUserAddresses = (queryOptions = {}) => {
  const { data: { userAddresses } = {}, loading, error, refetch } = useQuery(GET_USER_ADDRESSES, {
    fetchPolicy: 'cache-only', // don't do request on first run
    nextFetchPolicy: 'cache-first',
    ...queryOptions
  });

  return { userAddresses, loading, error, refetch };
};

export default useGetUserAddresses;
